import config from '../../config';
import APIService from './APIService';
import store from '../store';
import { objectToQueryParams } from '../helpers/common';

export default class BillingService extends APIService {
  /**
   * Use to generate a monthly billing csv
   * @param { Object: {month:number, year:number} } param query params
   *
   */
  static generateBillingCSV({ params }) {
    let url = config.baseUrlForMailSync;
    if (params) {
      url = `${url}/billing/${
        store.state.currentlySelectedOrgId
      }/csv?${objectToQueryParams({
        ...params
      })}`;
    }
    return this.get(url, 'blob');
  }
  /**
   * List Transactions
   *
   * @param {object} queryParams
   */
  static transactions({ page, pageSize, order }, cancelToken) {
    // eslint-disable-next-line
    let orgId = store.state.currentlySelectedOrgId || '';
    let url = config.baseUrlForBillingService;
    const params = objectToQueryParams({ pageSize, page, order });
    return this.get(`${url}/organisation/${orgId}/transactions?${params}`,undefined,undefined,cancelToken);
  }

  /**
   * List Payment Profiles
   *
   * @param {object} queryParams
   */
  static paymentProfiles({ page, pageSize }) {
    // eslint-disable-next-line
    let orgId = store.state.currentlySelectedOrgId || '';
    let url = config.baseUrlForBillingService;
    const params = objectToQueryParams({ pageSize, page });
    return this.get(`${url}/organisation/${orgId}/paymentProfile?${params}`);
  }

  /**
   * Create Payment Profile
   *
   * @param {string} cardToken
   */
  static createPaymentProfile(cardToken) {
    // eslint-disable-next-line
    let orgId = store.state.currentlySelectedOrgId || '';
    let url = config.baseUrlForBillingService;
    return this.post(`${url}/organisation/${orgId}/paymentProfile`, {
      chargifyToken: cardToken
    });
  }
  /**
   * @param {string} tenantId
   */
  static findCustomer(tenantId) {
    let url = config.baseUrlForBillingService;
    const params = objectToQueryParams({ tenantId });
    return this.get(`${url}/customer?${params}`);
  }

  /**
   * To get active subscriptions of a user
   */
  static getSubscriptions() {
    let url = config.baseUrlForBillingService;
    // eslint-disable-next-line
    let orgId = store.state.currentlySelectedOrgId || '';
    return this.get(`${url}/organisation/${orgId}/subscriptions/expand`);
  }

  /**
   * To get the product using product id
   *
   * @param {string} productId
   */
  static getProduct(productId) {
    let url = config.baseUrlForBillingService;
    return this.get(`${url}/product/${productId}`);
  }
  // Its a domain call for Syncing mails using Organisation id
  static syncMails(orgId) {
    let url = config.baseUrlForBillingService;
    return this.get(`${url}/domain/${orgId}`);
  }

  /**
   *
   */
  static componentListing() {
    let url = config.baseUrlForBillingService;
    return this.get(`${url}/component/filtered`);
  }

  /**
   *
   * @param {Array<{componentId, pricePointId, quantity }>} allocatedComponentList

   */
  static allocateComponent({ allocatedComponentList, subscriptionId }) {
    let url = config.baseUrlForBillingService;
    return this.post(
      `${url}/allocate/component/${subscriptionId}`,
      allocatedComponentList
    );
  }
  /**
   * Change Pack of an existing user
   *
   * @param {String} newProducthandle (select product slug)
   * @param {String} previousProductHandle (current product slug)
   * @param {String} subscriptionId (subscription id user)
   */
  static async changePack({
    newProducthandle,
    previousProductHandle,
    subscriptionId
  }) {
    let url = config.baseUrlForBillingService;
    return this.put(`${url}/update/pack`, {
      newProducthandle,
      previousProductHandle,
      subscriptionId
    });
  }

  /**
   * Get product using from productHandle
   *
   * @param {String} productHandle
   */
  static getProductFromHandle(productHandle) {
    let url = config.baseUrlForBillingService;
    return this.get(`${url}/product?productHandle=${productHandle}`);
  }

  /**
   *
   * @param {String} paymentProfileId
   */
  static defaultPaymentProfile(paymentProfileId) {
    let url = config.baseUrlForBillingService;
    let subscriptionId = store.state.subscriptions?.id || '';
    return this.post(
      `${url}/subscription/${subscriptionId}/defaultPaymentProfile/${paymentProfileId}`
    );
  }

  /**
   * Reactivate expired pack
   */
   static reactivatePack() {
    let url = config.baseUrlForBillingService;
    let subscriptionId = store.state.subscriptions?.id || '';
    return this.get(
      `${url}/subscription/reactivate/${subscriptionId}/`
    );
  }
  /**
   * To get Expiry date of trial pack
   */
  static getTrialExpiryData() {
    const url = config.baseUrlForBillingService;
    const orgId = store.state.currentlySelectedOrgId || '';
    return this.get(`${url}/subscription/expiry/${orgId}`);
  }
}
